import { jsx as _jsx } from "react/jsx-runtime";
import "./DoraTextArea.scss";
import { useCallback, useLayoutEffect, useRef } from "react";
const autoResizeHandler = (e) => {
    const el = e.currentTarget;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
};
const DoraTextArea = (props) => {
    const { placeholder, register, id, style } = props;
    const localRef = useRef(null);
    const { ref: registerRef } = register || {};
    const composedRef = useCallback((el) => {
        localRef.current =
            el;
        if (registerRef)
            registerRef(el);
    }, [registerRef]);
    useLayoutEffect(() => {
        if (localRef.current) {
            const el = localRef.current;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        }
    });
    const { ref: _ref, ...registerRest } = register || {};
    return (_jsx("textarea", { placeholder: placeholder, className: "dora-text-area", ...(id && { id }), ...registerRest, ref: composedRef, style: style, onInput: autoResizeHandler }));
};
const UFDoraTextArea = (props) => {
    return _jsx(DoraTextArea, { ...props });
};
export { DoraTextArea, UFDoraTextArea };
//# sourceMappingURL=DoraTextArea.js.map